var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0704 3.26875C13.0641 3.16875 12.0579 3.09375 11.0454 3.0375V3.03125L10.9079 2.21875C10.8141 1.64375 10.6766 0.78125 9.21415 0.78125H7.57665C6.1204 0.78125 5.9829 1.60625 5.8829 2.2125L5.75165 3.0125C5.1704 3.05 4.58915 3.0875 4.0079 3.14375L2.7329 3.26875C2.4704 3.29375 2.2829 3.525 2.3079 3.78125C2.3329 4.0375 2.5579 4.225 2.8204 4.2L4.0954 4.075C7.3704 3.75 10.6704 3.875 13.9829 4.20625C14.0016 4.20625 14.0141 4.20625 14.0329 4.20625C14.2704 4.20625 14.4766 4.025 14.5016 3.78125C14.5204 3.525 14.3329 3.29375 14.0704 3.26875Z",
    fill: "#FF3667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3991,
    d: "M12.9197 5.0875C12.7697 4.93125 12.5635 4.84375 12.351 4.84375H4.45097C4.23847 4.84375 4.02597 4.93125 3.88222 5.0875C3.73847 5.24375 3.65722 5.45625 3.66972 5.675L4.05722 12.0875C4.12597 13.0375 4.21347 14.225 6.39472 14.225H10.4072C12.5885 14.225 12.676 13.0437 12.7447 12.0875L13.1322 5.68125C13.1447 5.45625 13.0635 5.24375 12.9197 5.0875Z",
    fill: "#FF3667"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88867 10.625C6.88867 10.3661 7.09854 10.1562 7.35742 10.1562H9.43867C9.69756 10.1562 9.90742 10.3661 9.90742 10.625C9.90742 10.8839 9.69756 11.0938 9.43867 11.0938H7.35742C7.09854 11.0938 6.88867 10.8839 6.88867 10.625Z",
    fill: "#FF3667"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37012 8.125C6.37012 7.86612 6.57998 7.65625 6.83887 7.65625H9.96387C10.2228 7.65625 10.4326 7.86612 10.4326 8.125C10.4326 8.38388 10.2228 8.59375 9.96387 8.59375H6.83887C6.57998 8.59375 6.37012 8.38388 6.37012 8.125Z",
    fill: "#FF3667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.68498c3f29c0ecd094e6cc2ab82bdf22.svg";
export { ForwardRef as ReactComponent };